import AdminPageShell from '../../../design-system/patterns/AdminPageShell.jsx'
import { DataPanelCard } from '../../../design-system/patterns/index.js'
import DocumentsAdmin from '../../DocumentsAdmin.jsx'
import DriveImport from '../../DriveImport.jsx'

export default function DocumentsAdminPage() {
  return (
    <AdminPageShell
      title="Documents"
      subtitle="Upload and manage your document library for AI knowledge retrieval"
      contentClassName="analytics-tab-stack documents-admin-stack"
    >
      <DocumentsAdmin />

      <DataPanelCard title="Google Drive import" paddedBody layout="readable" aria-label="Google Drive import">
        <DriveImport embedded />
      </DataPanelCard>
    </AdminPageShell>
  )
}
